/**
 * [travel 旅行社票务]
 * @type {Array}
 */
export default [{
  path: 'travel',
  name: 'travel',
  redirect: 'travel/choose_date',
  component: resolve => require(['@/views/travel/index'], resolve),
  meta: {
    title: '个人预约',
    auth: false
  },
  children: [{
      path: 'choose_date',
      name: 'travel_choose_date',
      component: resolve => require(['@/views/travel/chooseDate'], resolve),
      meta: {
        title: '选择参观日期',
        auth: false
      }
    },
    {
      path: 'fill_info',
      name: 'travel_fill_info',
      component: resolve => require(['@/views/travel/fillInInfo'], resolve),
      meta: {
        title: '填写预约信息',
        auth: true
      }
    },
    {
      path: 'confirm_info',
      name: 'travel_confirm_info',
      component: resolve => require(['@/views/travel/confirmInfo'], resolve),
      meta: {
        title: '确认预约信息',
        auth: true
      }
    },
    {
      path: 'success',
      name: 'travel_success',
      component: resolve => require(['@/views/travel/success'], resolve),
      meta: {
        title: '预约成功',
        auth: true
      }
    },
    {
      path: 'order_detail',
      name: 'travel_order_detail',
      component: resolve => require(['@/views/travel/orderDetail'], resolve),
      meta: {
        title: '预约详情',
        auth: true
      }
    },
  ]
}]



// WEBPACK FOOTER //
// ./src/router/modules/travel.js